export default __webpack_public_path__ + "static/media/P20010.25b9f8e3.png";